import { render, staticRenderFns } from "./SAccordion.vue?vue&type=template&id=3fa9485a&lang=pug"
import script from "./SAccordion.vue?vue&type=script&setup=true&lang=ts"
export * from "./SAccordion.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports